"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequesttypeApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class RequesttypeApi extends runtime.BaseAPI {
    /**
     * This method returns all customer request types used in the Jira Service Management instance, optionally filtered by a query string.  Use [servicedeskapi/servicedesk/\\{serviceDeskId\\}/requesttype](#api-servicedesk-serviceDeskId-requesttype-get) to find the customer request types supported by a specific service desk.  The returned list of customer request types can be filtered using the `query` parameter. The parameter is matched against the customer request types\' `name` or `description`. For example, searching for \"Install\", \"Inst\", \"Equi\", or \"Equipment\" will match a customer request type with the *name* \"Equipment Installation Request\".  **Note:** This API will filter out hidden request types (aka.request types without groups) when `query` is provided.  **[Permissions](#permissions) required**: Any
     * Get all request types
     */
    getAllRequestTypesRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['searchQuery'] != null) {
                queryParameters['searchQuery'] = requestParameters['searchQuery'];
            }
            if (requestParameters['serviceDeskId'] != null) {
                queryParameters['serviceDeskId'] = requestParameters['serviceDeskId'];
            }
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/requesttype`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTORequestTypeDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all customer request types used in the Jira Service Management instance, optionally filtered by a query string.  Use [servicedeskapi/servicedesk/\\{serviceDeskId\\}/requesttype](#api-servicedesk-serviceDeskId-requesttype-get) to find the customer request types supported by a specific service desk.  The returned list of customer request types can be filtered using the `query` parameter. The parameter is matched against the customer request types\' `name` or `description`. For example, searching for \"Install\", \"Inst\", \"Equi\", or \"Equipment\" will match a customer request type with the *name* \"Equipment Installation Request\".  **Note:** This API will filter out hidden request types (aka.request types without groups) when `query` is provided.  **[Permissions](#permissions) required**: Any
     * Get all request types
     */
    getAllRequestTypes(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllRequestTypesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.RequesttypeApi = RequesttypeApi;
//# sourceMappingURL=RequesttypeApi.js.map